/**
 * Notification component script class
 *
 * @package    Common
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './styles.scss';

import {
    removeNotify,
} from 'Actions/notifications';
import {
    notificationType,
} from 'Types/notification';

import NotificationItem from './NotificationItem.jsx';

@connect(
    (store) => ({
        notifications: store.notifications,
    }),
    (dispatch) => ({
        removeNotify: (id) => dispatch(removeNotify(id)),
    }),
)
export default class NotificationList extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        notifications: PropTypes.arrayOf(notificationType).isRequired,
        removeNotify: PropTypes.func.isRequired,
    };

    removeNotify = (id) => {
        this.props.removeNotify(id);
    };

    render () {
        const { notifications } = this.props;

        return (
            <div className="notification-list">
                { notifications.map((item) => (
                    <NotificationItem key={ item.id } item={ item } removeNotify={ this.removeNotify }/>
                )) }
            </div>
        );
    }
}
